import 'classlist.js';

let html = document.querySelector('html');
html.classList.remove('no-js');
html.classList.add('js');